// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cZonU-gu{display:flex;flex-direction:column;gap:max(1.5rem,min(1.67vw,2rem));overflow:hidden;word-wrap:break-word}.cZonU-gu .E4cr\\+-8H{font-size:max(.88rem,min(.83vw,1rem));width:100%}.\\--G-d\\+pp{align-items:flex-start;justify-content:space-between;padding:.5rem}.\\--G-d\\+pp,.NAAZbPQO{display:flex;gap:max(1.13rem,min(1.25vw,1.5rem))}.NAAZbPQO{flex-direction:column;overflow:hidden}.jC26Tksw{border-radius:9999px;flex-shrink:0;height:max(5rem,min(5.21vw,6.25rem));-o-object-fit:cover;object-fit:cover;-o-object-position:top;object-position:top;outline:.31rem solid var(--color-primary);outline-offset:.19rem;overflow:hidden;width:max(5rem,min(5.21vw,6.25rem))}.mVzLBzHg{font-size:max(1.13rem,min(1.25vw,1.5rem));font-weight:600;line-height:1.33;text-wrap:balance}.GXNZqnRo{font-size:max(1rem,min(.94vw,1.13rem));opacity:.8}.GXNZqnRo,.wp2Jy7-9{line-height:1.44}.wp2Jy7-9{font-size:max(.88rem,min(.94vw,1.13rem))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "cZonU-gu",
	"btn": "E4cr+-8H",
	"header": "--G-d+pp",
	"headerMeta": "NAAZbPQO",
	"photo": "jC26Tksw",
	"name": "mVzLBzHg",
	"location": "GXNZqnRo",
	"text": "wp2Jy7-9"
};
module.exports = ___CSS_LOADER_EXPORT___;
